import { render, staticRenderFns } from "./TicketSuccess.vue?vue&type=template&id=6ee6aafd&scoped=true"
import script from "./TicketSuccess.vue?vue&type=script&lang=js"
export * from "./TicketSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee6aafd",
  null
  
)

export default component.exports